import { Link } from "react-router-dom";

const quickLinks = [
  { label: "电影频道", to: "/category/movie" },
  { label: "电视剧频道", to: "/category/tv" },
  { label: "综艺频道", to: "/category/variety" },
  { label: "影视资讯", to: "/news" },
  { label: "关于我们", to: "/about" },
];

const friendLinks = ["影视观察", "光影周刊", "剧集日报", "综艺现场", "观影指南"];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-900 text-secondary-100">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-xl text-background-50"></i>
              </span>
              <span className="font-heading font-bold text-lg text-background-50">
                蘑菇<span className="text-primary-400">TV</span>
              </span>
            </div>
            <p className="text-sm leading-relaxed text-secondary-300">
              蘑菇TV 致力于为影迷提供丰富的电影、电视剧与综艺内容浏览体验，以及最新影视资讯，让好内容触手可及。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
              频道导航
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-secondary-300 hover:text-primary-400 transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
              联系我们
            </h4>
            <ul className="space-y-2.5 text-sm text-secondary-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@mushroomtv.demo</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-400"></i>
                <span>400-800-1234</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-400"></i>
                <span>服务时间 09:00 - 22:00</span>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <span className="w-9 h-9 rounded-full bg-secondary-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-lg"></i>
              </span>
              <span className="w-9 h-9 rounded-full bg-secondary-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-lg"></i>
              </span>
              <span className="w-9 h-9 rounded-full bg-secondary-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-movie-line text-lg"></i>
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
              友情链接
            </h4>
            <ul className="space-y-2.5">
              {friendLinks.map((item) => (
                <li key={item}>
                  <span className="text-sm text-secondary-300 hover:text-primary-400 transition-colors cursor-pointer">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-secondary-400">
          <p>© 2026 蘑菇TV MushroomTV. 本站为演示站点，所有内容均为虚拟数据。</p>
          <p className="flex items-center gap-2">
            <i className="ri-information-line"></i>
            播放功能为前端演示状态，不提供真实播放与下载
          </p>
        </div>
      </div>
    </footer>
  );
}